namespace $.$$ {

	export class $shm_hitalama_profile_switch extends $.$shm_hitalama_profile_switch {

		login(): string {
			return this.$.$shm_hitalama_profile.current()?.Login()?.val() ?? ''
		}

		sub(): readonly ( any )[] {
			return this.login() ? super.sub() : this.buttons()
		}

		@ $mol_action
		exit() {
			if( this.$.$shm_hitalama_settings.selfhosted_tauri_enabled() ) {
				this.$.$shm_hitalama_app.selfhosted_tauri_logout( true )
			}
			this.$.$giper_baza_auth.current( this.$.$giper_baza_auth.grab() )
			this.$.$shm_hitalama_profile.home().Hitalama_profile(null)?.remote( null )
		}
	}

}
